const Base_url = '/'
// const Base_url = 'http://global.sichuanair.com/'
export default Base_url